import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/courseCenter',
    name: 'courseCenter',
    component: () => import(/* webpackChunkName: "about" */ '../views/courseCenter.vue')
  },
  {
    path: '/musicalIntroductionCenter',
    name: 'musicalIntroductionCenter',
    component: () => import(/* webpackChunkName: "about" */ '../views/musicalIntroductionCenter.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import(/* webpackChunkName: "about" */ '../views/aboutUs.vue')
  },
  {
    path: '/courseDetail',
    name: 'courseDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/courseDetail.vue')
  },
  {
    path: '/kechengjieshaoDetail',
    name: 'kechengjieshaoDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/kechengjieshaoDetail.vue')
  },
  
  {
    path: '/musicalIntroductionDetail',
    name: 'musicalIntroductionDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/musicalIntroductionDetail.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
